import { useFetchRoadAccidentWeatherConditionsQuery } from '../../../../../api/rtk/base/slices/objectTypes/roadAccidentsApiSlice'
import type { SpecialContributor } from '../types'

export const roadAccidentsContributor: SpecialContributor = {
    id: 'roadAccidents',
    useContribute: ({ objectTypeName, objectId }) => {
        const enabled = objectTypeName === 'RoadAccidents'
        const { data: weatherConditions, isFetching } = useFetchRoadAccidentWeatherConditionsQuery({ id: objectId as any }, { skip: !enabled })

        return {
            computedFields: enabled ? {
                WeatherConditionString: {
                    isLoading: isFetching,
                    value: weatherConditions?.value?.length ? weatherConditions.value.map((i: any) => i.WeatherConditionDescription).join(', ') : undefined
                }
            } : undefined
        }
    }
}


